import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/banner/base"

const banner = {
  bannerList(pageSize, limit, title) {
    return axios.get(pre + `/bannerList`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          title: title,
        }
    });
  },
  getBannerInfo(id) {
    return axios.get(pre + `/getBannerInfo`, {params: {id: id}});
  },
  saveBanner(params) {
    return axios.post(pre + `/saveBanner`, qs.stringify(params));
  },
  updateConfigSort(params) {
    return axios.post(pre + `/updateConfigSort`, qs.stringify(params));
  },
  deleteBanner(id) {
    return axios.post(pre + `/deleteBanner`, qs.stringify({id: id}));
  },
}
export default banner;



// WEBPACK FOOTER //
// ./src/api/config/banner.js